import { reatomAsync, withDataAtom } from "@reatom/async";
import { withAbort } from "@reatom/framework";
import { ExportTaskIdDto } from "definitions/exporter";
import { API } from "src/api.ts";
import { withIsLoadingAtom } from "src/common/pipes";

export const getExportTaskOptionsRequest = reatomAsync(
  async (ctx, data: ExportTaskIdDto) => {
    return API.exporterQueueApi
      .exportControllerGetExportTaskOptions(data, {
        signal: ctx.controller.signal,
      })
      .then((response) => response.data);
  },
  "getExportTaskOptionsRequest",
).pipe(withDataAtom(null), withAbort(), withIsLoadingAtom());
